import { useInterfaceLanguage } from '@/shared/i18n';

import { PeriodTab } from './components/PeriodTab';
import { Container } from './styled';

type PeriodToggleProps = {
  yearlySelected: boolean;
  onToggle: (yearlySelected: boolean) => void;
};

// The bare Monthly/Annual segmented pill, reused by BillingPeriodTabs and the comparison table.
export const PeriodToggle = ({ yearlySelected, onToggle }: PeriodToggleProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <Container aria-label={t('pricing.billing.aria')} role="group">
      <PeriodTab isActive={!yearlySelected} onSelect={() => onToggle(false)}>
        {t('pricing.billing.monthly')}
      </PeriodTab>
      <PeriodTab isActive={yearlySelected} onSelect={() => onToggle(true)}>
        {t('pricing.billing.annual')}
      </PeriodTab>
    </Container>
  );
};
